import React, {useState, useEffect} from "react"
import moment from "moment-timezone"
import styled from "styled-components"
import {useAuth0} from "@auth0/auth0-react"
// redux
import {useDispatch, useSelector} from "react-redux"
import {coachDataSelector, fetchBookingsByCoachId, toggleCoachStatus, bulkCancelBookingsDisable} from "../coachesSlice"

// Components
import ToggleDelay from "components/shared/ToggleDelay"
import {Modal} from "@uprise/modal"
// UI
import {Medium} from "@uprise/text"
import {H4} from "@uprise/headings"
import {Button} from "@uprise/button"

const ButtonContainer = styled.div`
	display: flex;
`
const PrimaryButton = styled(Button)`
	width: 100%;
	min-width: 100px;
	height: 50px;
	margin: 10px 6px 0;
	outline: none;
`

const DisableDialog = ({id, disabled}) => {
	const dispatch = useDispatch()
	const [loading, isLoading] = useState(false)
	const [token, setToken] = useState(null)
	const [showModal, setShowModal] = useState(false)
	const [bookings, setBookings] = useState([])
	const [checked, setChecked] = useState(disabled)

	const {getAccessTokenSilently} = useAuth0()
	const {allCoachesApiState} = useSelector(coachDataSelector)

	useEffect(() => {
		setChecked(disabled)
	}, [disabled])

	useEffect(() => {
		;(async () => {
			const token = await getAccessTokenSilently()
			setToken(token)
		})()
	}, [])

	useEffect(() => {
		if (allCoachesApiState.totalCount > 0) {
			if (allCoachesApiState.coaches[id]?.bookings) setBookings(allCoachesApiState.coaches[id]?.bookings)
		}
	}, [allCoachesApiState])

	const handleSubmit = () => {
		const bookingIds = bookings.map(booking => booking.id)
		if (token) {
			if (!bookings.length) {
				const status = disabled ? false : true
				dispatch(toggleCoachStatus({token, id, status}))
			} else {
				dispatch(
					bulkCancelBookingsDisable({
						token,
						bookingIds,
						coachId: id,
						cancelReason: "inTime"
					})
				)
			}
			handleClose()
		}
	}

	const handleClose = () => {
		setShowModal(false)
	}

	const _handleChangeCoachStatus = async () => {
		if (token) {
			dispatch(fetchBookingsByCoachId({token, id}))
			setShowModal(true)
		}
	}

	return (
		<>
			<ToggleDelay
				testId='toggle'
				checked={!checked}
				value={checked}
				onChange={() => _handleChangeCoachStatus()}
				backgroundColorChecked={"#7d60ff"}
				width='42'
				height='24'
				sliderHeight='20.8'
				sliderWidth='20.8'
				translate='18'
			/>
			<Modal
				isOpen={showModal}
				handleClose={handleClose}
				padding={"24px"}
				backgroundColor={"#ffffff"}
				width={"800px"}
				scroll={true}
				textAlign='center'
			>
				{bookings.length ? (
					<H4>{`The coach has following sessions planned that will be cancelled. Do you want to disable the coach?`}</H4>
				) : (
					<H4>{`Are you sure you want to ${!checked ? "disable" : "enable"} the coach : ${
						allCoachesApiState.coaches[id]?.name
					}?`}</H4>
				)}
				{!!bookings.length &&
					bookings.map(booking => (
						<Medium className='m-b-5' key={booking.id}>
							{`${moment(booking.start).format("YYYY-MM-DD hh:mm")}, ${booking.email}`}
						</Medium>
					))}
				<ButtonContainer className='m-t-5'>
					<PrimaryButton
						variant={"primary"}
						title={"No"}
						style={{paddingRight: 10, paddingLeft: 10}}
						onClick={() => setShowModal(false)}
					/>
					<PrimaryButton
						variant={"primary"}
						title={"Yes"}
						style={{paddingRight: 10, paddingLeft: 10}}
						isLoading={loading}
						onClick={handleSubmit}
					/>
				</ButtonContainer>
			</Modal>
		</>
	)
}

export default DisableDialog
